export const countUnreadConversations = (tickets) => {
	if (!Array.isArray(tickets) || tickets.length === 0) {
		return 0;
	}

	const seen = new Set();
	let total = 0;

	for (const ticket of tickets) {
		if ((ticket.unreadMessages || 0) <= 0) {
			continue;
		}
		const key =
			ticket.contactId != null || ticket.whatsappId != null
				? `${ticket.contactId ?? "c"}:${ticket.whatsappId ?? "w"}`
				: `ticket:${ticket.id}`;
		if (seen.has(key)) {
			continue;
		}
		seen.add(key);
		total += 1;
	}

	return total;
};

export const formatTicketTabBadgeCount = (total, hasMore) => {
	const n = Number(total) || 0;
	if (n <= 0) {
		return 0;
	}
	if (hasMore) {
		return `${n}+`;
	}
	return n;
};

export const formatUnreadMessagesBadgeCount = (total) => {
	const n = Number(total) || 0;
	if (n <= 0) {
		return 0;
	}
	if (n > 99) {
		return "99+";
	}
	return n;
};
